import { Component, OnInit, trigger, state, animate, style, transition, keyframes } from '@angular/core';
import { DomSanitizer, SafeResourceUrl, SafeUrl} from '@angular/platform-browser';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { UserService } from '../../services/user.service';
import { Account } from '../../models/account';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  providers: [ UserService ],
  styleUrls: ['./logout.component.css']
})
export class LogoutComponent implements OnInit {

	public accounts: Account;
	constructor(private userService: UserService,
				private router: Router,
				private sanitizer: DomSanitizer,
				private location: Location) { }
	
	title: any;
	header: any;

	/* On with the show */
	ngOnInit() {
		this.accounts = null;
		this.userService.logout().subscribe(result => {	
			console.log(result);
		});

		this.title = 'Identity';
		this.header = this.sanitizer.bypassSecurityTrustStyle( 'url( "/assets/img/header-modules.jpg")' );

		window.location.pathname = '/login';
	}

}



// WEBPACK FOOTER //
// C:/Users/Asylum/identity-vagrant/src/asylum-idenetity/src/app/user/logout/logout.component.ts